import { PageHeading } from '../../components/common/pageHeading/PageHeading'
import bg from '../../assests/images/inventory_bg.avif'
import { SpendingData } from '../../components/expense/spending/SpendingData'
export const SpendingPage = () => {
  return (
    <div className='mb-5'>
      <PageHeading title={'Expenses'} />
      <section className='container py-2'>
        <div className='row align-items-center'>
          <div className='col-12 col-md-6 text-center'>
            <h1 className='display-4'>Supply Corner</h1>
            <p className='lead'>Expense details</p>
            <a href='#' className='btn btn-outline-warning btn-lg'>
              Dashboard
            </a>
          </div>
          <div className='col-md-6'>
            <img
              src={bg}
              className='img-fluid rounded'
              alt='Order management'
            />
          </div>
        </div>
      </section>
      <SpendingData />
    </div>
  )
}
